module.exports = __webpack_public_path__ + "img/box-handshake.d116539d.svg";